var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"1000px"},attrs:{"id":"c"}},[_c('canvas',_vm._b({attrs:{"id":_vm.pageNumber}},'canvas',_vm.canvasAttrs,false),[_vm._v(_vm._s(_vm.pageNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }